import { Block, useBlockRenderer } from '@/hooks/use-block-renderer'
import { BlockRenderer } from '@/Components/block-renderer'

export default function Tariffs() {
  const blocks = useBlockRenderer('tariffs') as Block[]
  return <BlockRenderer blocks={blocks} />
}
